export const defaultTranslation = {
  chat: {
    pickMeetingType: 'Pick a meeting type to display availability',
    loadingDatesAndTimes: 'Loading dates & times',
    timeslotSelectionIsNoLongerAvailable:
      'Timeslot selection is no longer available. Please select a new one.',
    cancelRescheduling: 'Cancel Rescheduling',
    showFullCalendar: 'Show full calendar',
    showOnlySuggestedTimes: 'Show only suggested times',
    sessionExpired: 'Session Expired',
    sessionExpiredDescription:
      'Your scheduling session has timed out due to inactivity, and the available times are no longer active.',
    startNewChat: 'Start New Chat',
    youWillReceiveMeetingInvitationShortly: 'You will receive a meeting invitation shortly',
    sendFormField: 'Send',
  },
  concierge: {
    bookingLoader: 'Booking meeting',
    confirm: 'Confirm',
    confirmButton: 'Confirm Meeting',
    connectingScreen: "We're connecting you with someone now. Please hold tight...",
    dayBookHeader: 'What day is best for you?',
    domainMaxMeetingsReached:
      'We apologize but the maximum number of people in your organization have already signed up. Please contact the sender if you think this is not correct.',
    confirmedText: 'You will receive a meeting invitation shortly',
    description: 'Description',
    guests: 'Guests',
    event: 'Event',
    durationHour: '1 Hour',
    durationHours: '{duration} Hours',
    durationMinutes: '{duration} Minutes',
    findAnotherTime: 'Find another time',
    location: 'Location',
    meetingLength: '{duration} minute meeting',
    meetingLengthText: 'Meeting length',
    noRescheduleMeetingLinkExpired:
      'This meeting is now in the past and you can no longer reschedule. Contact the meeting owner if you wish to book another meeting.',
    noAvailableAssignees: 'There are no available assignees',
    noAvailableTimeSlotsOnThisDay: 'No available time slots on this day',
    noAvailableTimeSlots: 'No available time slots',
    tryAnotherDay: 'Try another day',
    noLongerAvailable: 'This time is no longer available. Please select another time',
    noRepFoundCall:
      'Sorry, nobody is available right now. Please schedule a time below or someone will reach out to you shortly.',
    noTimeThatWorks: "Don't see a time that works for you?",
    pickNewTime: 'Pick a new time:',
    pickNewTimeWith: 'Pick a new time with:',
    pickTimeText: 'Pick a time:',
    pickTimeWithText: 'Pick a time with:',
    bookNewGroupTimeText: 'Book a new group meeting type with',
    bookNewTimeText: 'Book a new meeting type with',
    bookTimeText: 'Book with',
    bookGroupTimeText: 'Book group meeting with',
    pleaseWait: 'Please wait',
    previousDateTimeBooked: 'Previous schedule',
    prospectMaxMeetingsReached:
      "Please visit your original confirmation email if you'd like to reschedule your meeting for a different time/day.",
    providePhone: 'We need a valid phone number to connect you. Please provide your number below',
    rescheduleButton: 'Reschedule',
    rescheduleConfirm:
      'Reschedule was confirmed for {time} on {date}. You will receive an updated meeting invite.',
    rightsReserved: '© Chili Piper, Inc. All rights reserved',
    submitButton: 'Submit',
    time: 'Time',
    timeBookHeader: 'What time works?',
    timeZone: 'Time Zone',
    viewFullCalendar: 'View full calendar',
    wrongAgain: 'Wrong time again?',
    wrongTime: 'Wrong time?',
    youAreMeeting: 'You are meeting with',
    bookedWith: 'Booked with',
    meetingCanceled: 'The meeting has been canceled',
    meetingCancelConfirmation: 'Are you sure you want to cancel this meeting?',
    meetingCancelButton: 'Cancel Event',
    meetingRescheduleButton: 'Reschedule Event',
    meetingWasCanceledNoReschedule:
      'This meeting was canceled and you can no longer reschedule. Contact the meeting owner if you want to book another meeting.',
    showFullBookingDetailsButton: 'Show Full Booking Details',
    tabAlreadyOpened: 'This link was opened in another tab. Continue from there and close this one',
    myPhone: 'My Phone',
    hostsPhone: 'Host’s Phone',
    myLocation: 'My Location',
    hostsLocation: 'Host’s Location',
    useHostsSettings: 'Use Host’s settings',
    provideMyOwn: 'Provide my own',
    meetingLocation: 'Meeting location',
    required: 'Required',
    provideYourOwnMeetingLink:
      'Provide your own meeting link or dial-in. The details will be included in the invite once the meeting is booked.',
    chooseMeetingLocation: 'Choose a meeting location',
    confirmMeeting: 'Confirm Meeting',
    pickDifferentTime: 'Pick а Different Time',
    conferenceDetails: 'Conference Details',
    useHostsConferenceDetails: "Use Host's Conference Details",
    callTheHost: 'You will call the number provided',
    callTheGuest: 'The meeting host will call you',
    googleMeetCalendarInvite: 'Google Meet link is in the calendar invite',
    microsoftTeamsCalendarInvite: 'Microsoft Teams link is in the calendar invite',
    phone: 'Phone',
    enter: 'Enter',
    youRequestedMeetingWith: 'You have requested a meeting with:',
    youSetupMeetingWith: 'You set up a meeting with:',
    pickTimeRequestText: 'Request a meeting with:',
    pickNewTimeRequestText: 'Request a new meeting with:',
    confirmedTextMeetingRequest:
      'You will get a calendar invite soon if someone is available to talk to you',
    almostThere: 'Almost there!',
    inviteAdditionalGuests: 'Invite Additional Guests',
    change: 'Change',
    sentBookingDetailsEmailText: 'An email has been sent with the full booking details!',
    weSentBookingDetailsEmailText: 'We’ve sent an email with your full booking details',
    bookingDetails: 'Booking Details',
    teamMember: '{team} team member',
    bookATime: 'Book a time',
    doYouSeeInvitation: 'Do you see the invitation?',
    great: 'Great!',
    thanksISeeIt: 'Thanks, I see it',
    addToCalendar: 'Add to Calendar',
  },
}
